import * as React from "react"
import { useIntl } from "react-intl"
import { useHistory } from "react-router-dom"
import { useApplicationContext } from "context/applicationContext"

import { isAccessPrivileges } from "helpers/accessPrivilegesUtils"
import { logout } from "helpers/authUtils"

import Dropdown, { dropdownOptionType } from "components/Shared/Dropdown"
import { USER_MENU_OPTIONS } from "components/Header/constants"

import { USER_MANAGEMENT_MODULE } from "constants/features"
import { CHANGE_PW, USER_MANAGEMENT } from "constants/paths"

import "./index.scss"
import { Button } from "@walmart-web/livingdesign-components"
import { ChevronDown } from "@walmart-web/livingdesign-icons"

const UserMenu: React.FC = () => {
	const history = useHistory()
	const intl = useIntl()
	const { username, organizationName } = useApplicationContext()

	const actionsOnMenuOptionClick: {
		[key: string]: () => void
	} = {
		[USER_MENU_OPTIONS.ADMINISTRATION]: () => history.push(USER_MANAGEMENT),
		[USER_MENU_OPTIONS.CONFIGURATION]: () => history.push(CHANGE_PW),
		[USER_MENU_OPTIONS.LOGOUT]: () => logout(true),
	}

	const userHasAccess = (menuOption: string) =>
		menuOption !== USER_MANAGEMENT_MODULE ||
		isAccessPrivileges(USER_MANAGEMENT_MODULE)

	const prepareUserMenuOptions = (): Array<dropdownOptionType> =>
		Object.values(USER_MENU_OPTIONS)
			.map((menuOption) => ({
				id: menuOption,
				name: intl.formatMessage({
					id: `phronesis.usermenu.${menuOption.toLowerCase()}`,
				}),
			}))
			.filter((menuOption) => userHasAccess(menuOption.id))

	const handleClickOnUserMenuOption = (optionId: string) => {
		const actionOnMenuOptionClick = actionsOnMenuOptionClick[optionId]
		actionOnMenuOptionClick()
	}

	return (
		<>
			<div className="menu-user" id="button-organization">
				<div className="button-container">
					<Button variant="primary" UNSAFE_className="button">
						{organizationName}
					</Button>
				</div>
			</div>
			<div className="menu-user" id="dialog-menu">
				<Dropdown
					buttonIconRight={
						<ChevronDown size="small" className="chevron_down" />
					}
					buttonName={username}
					onSelectFunction={handleClickOnUserMenuOption}
					dropdownOptions={prepareUserMenuOptions()}
				/>
			</div>
		</>
	)
}

export default UserMenu
